import React from 'react'
import { useWeblinksGetWeblinksQuery } from '@app/services/auto-generated/weblinks'
import { Box, Container, Fab, List, Skeleton, Tooltip } from '@common/components'
import { useToggle } from '@common/hooks'
import { AddIcon, EditOutlinedIcon } from '@common/icons'
import { SearchBar, Weblink, WeblinkModal } from '@features/weblinks/components'

const DisplayWeblinks = () => {
  const [searchValue, setSearchValue] = React.useState('')
  const { open, handleClose, handleOpen } = useToggle(false)
  const {
    data: weblinks,
    isSuccess,
    isError,
    isLoading,
  } = useWeblinksGetWeblinksQuery({ query: searchValue ?? '' })
  return (
    <Container sx={{ width: '100%', height: '100%' }}>
      <SearchBar value={searchValue} onChange={setSearchValue} sx={{ mb: 4 }} />
      <Box sx={{ marginTop: '30px' }}>
        {isLoading && (
          <Container>
            <Skeleton height={50} variant='rounded'></Skeleton>
          </Container>
        )}
        {isSuccess && (
          <List>
            {weblinks.map((e, i) => {
              return <Weblink title={e.title} url={e.link} key={i} tags={e.tags} id={e.id} />
            })}
          </List>
        )}
      </Box>
    </Container>
  )
}
export default DisplayWeblinks
